import React, { ReactChildren, useRef } from "react";
import { Box, Card, CardBody, CardFooter, CardHeader, Image, Stack, Text } from "grommet";
import { AliasViewModel } from "./AliasStore";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import ParallaxTilt2 from "../components/ParallaxTilt2";
import { normalizeColor } from "grommet/utils";
import { useDarkMode } from "../components/DarkModeSwitch";
import Theme from "../utils/Theme";

export const AliasCard = ({ alias, width, children }: { alias: AliasViewModel; width?: number; children?: any }) => {
    const [isDarkMode] = useDarkMode();
    const background = normalizeColor("background", Theme, isDarkMode);
    return (
        <Link to={`/aliases/${alias.id}`} style={{ textDecoration: "none", color: "unset" }}>
            <ParallaxTilt2 style={{ backgroundImage: "url(" + alias.splashUri + ")", backgroundColor: background }}>
                <Card width={!!width ? width + "px" : "250px"} height={!!width ? width * 1.5 + "px" : "375px"}>
                    <CardBody align="center" justify="center">
                        <Box align="center">
                            <Image src={alias.photoUri} fit="contain" width="90%" height="90%" />
                        </Box>
                    </CardBody>
                    <CardHeader pad="small" justify="center" fill="horizontal" background={{ color: background, opacity: 0.7 }}>
                        <Text textAlign="center">{alias.name}</Text>
                    </CardHeader>
                    <CardFooter pad="small" background="background-front">
                        <Box direction="row" gap="small" justify="between" fill="horizontal">
                            {...children}
                        </Box>
                    </CardFooter>
                </Card>
            </ParallaxTilt2>
        </Link>
    );
};
